import { render } from "./HowItWorksPage.vue?vue&type=template&id=39981c90"
import script from "./HowItWorksPage.vue?vue&type=script&lang=js"
export * from "./HowItWorksPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__